
export const environment = {
  production: false,
  commitHash: '086cdc9',
  commitDate: 'Mon Jun 16 09:42:12 2025 -0500',
  deployDate: '2025-06-16T14:42:33Z',
  apiUrl: 'http://localhost:8080',
  paypalClientId: 'AZlcAYm2oQZoYlK1IH384ZOiLUc0r1tqhhc0j-oslOD_wCJcQkFYVP2Qv2hyGQ191SswW0begTVYUT2i',
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
